import React from 'react';

// Page shell only for now — no rules, no engine yet. The rule composer
// (trigger + action, restricted to what the pipeline actually allows) gets
// built once the available trigger/action types are decided.
export default function AutomationsPage() {
  return (
    <div style={s.page}>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>Automations</h1>
          <p style={s.sub}>Automatically move leads or log activity based on rules you define</p>
        </div>
        <button style={s.createBtn} onClick={() => alert('Automation builder coming soon.')}>
          + Create Automation
        </button>
      </div>

      <div style={s.emptyState}>
        <div style={s.emptyIcon}>⚡</div>
        <div style={s.emptyTitle}>No automations yet</div>
        <div style={s.emptyText}>
          Automations will let you automatically move a lead to the next stage when a specific activity is
          logged, or log an activity when a lead reaches a stage — built on top of the connections you've
          set up in the Pipeline Builder.
        </div>
        <button style={s.createBtnSecondary} onClick={() => alert('Automation builder coming soon.')}>
          Create your first automation
        </button>
      </div>
    </div>
  );
}

const s = {
  page: { padding: '1.5rem', fontFamily: 'Inter, system-ui, sans-serif', maxWidth: 900, margin: '0 auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
  title: { fontSize: 20, fontWeight: 600, margin: 0, color: '#1a1a1a' },
  sub: { fontSize: 13, color: '#888', marginTop: 4 },
  createBtn: { background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 16px', fontSize: 13, fontWeight: 500, cursor: 'pointer', flexShrink: 0 },
  emptyState: { background: '#fff', border: '1px dashed #d9d7cf', borderRadius: 16, padding: '3rem 2rem', textAlign: 'center' },
  emptyIcon: { fontSize: 32, marginBottom: 12 },
  emptyTitle: { fontSize: 15, fontWeight: 600, color: '#1a1a1a', marginBottom: 8 },
  emptyText: { fontSize: 13, color: '#888', lineHeight: 1.6, maxWidth: 460, margin: '0 auto 20px' },
  createBtnSecondary: { background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
};
